import { Reveal, Eyebrow } from "./Reveal";

const STEPS = [
  ["01", "Grab your license", "One payment. No subscriptions, no hidden fees, no monthly bills."],
  ["02", "We install everything", "Free installation on your free domain with lifetime web hosting."],
  ["03", "Brand it & launch", "Set your credit rates, add your branding and open the doors to members."],
];

export const Steps = () => (
  <section id="how" className="relative border-t border-slate-200 bg-[#F3F7FF] py-28 lg:py-36" data-testid="how-section">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal className="grid gap-6 lg:grid-cols-12">
        <div className="lg:col-span-5"><Eyebrow>How it works</Eyebrow></div>
        <h2 className="font-display text-3xl font-extrabold leading-tight tracking-tight text-slate-900 sm:text-4xl lg:col-span-7">From zero to your own traffic exchange in three moves.</h2>
      </Reveal>
      <div className="mt-20 grid gap-12 md:grid-cols-3 md:gap-8">
        {STEPS.map(([n, t, d], i) => (
          <Reveal key={n} delay={i * 0.12}>
            <div className="group border-t-2 border-slate-300 pt-8 transition-colors duration-500 hover:border-blue-600" data-testid={`step-${n}`}>
              <span className="font-display text-outline block text-7xl font-black transition-colors duration-500 group-hover:text-blue-600 sm:text-8xl">{n}</span>
              <h3 className="font-display mt-6 text-xl font-bold text-slate-900">{t}</h3>
              <p className="mt-3 text-slate-600">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
